module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "advantage-addition-wrapper"
  }, [_c('div', {
    staticClass: "advantage-addition"
  }, [_c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": function($event) {
        return _vm.deleteFunc(_vm.instanceObject.id)
      }
    }
  }), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Заголовок"
    },
    on: {
      "change": function($event) {
        return _vm.updateFunc(_vm.instanceObject)
      }
    },
    model: {
      value: (_vm.instanceObject.title),
      callback: function($$v) {
        _vm.$set(_vm.instanceObject, "title", $$v)
      },
      expression: "instanceObject.title"
    }
  })], 1), _vm._v(" "), (_vm.useEditor) ? _c('b-field', [_c('Editor', {
    attrs: {
      "editorToolbar": _vm.customToolbar,
      "id": ("e" + (_vm.instanceObject.id))
    },
    model: {
      value: (_vm.text),
      callback: function($$v) {
        _vm.text = $$v
      },
      expression: "text"
    }
  })], 1) : _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Текст",
      "type": "textarea"
    },
    on: {
      "change": function($event) {
        return _vm.updateFunc(_vm.instanceObject)
      }
    },
    model: {
      value: (_vm.instanceObject.description),
      callback: function($$v) {
        _vm.$set(_vm.instanceObject, "description", $$v)
      },
      expression: "instanceObject.description"
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e5788dc8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BondedLoan/investorComponents/AdvantageOrReason.vue
// module id = 1008
// module chunks = 0